<template>
  <v-list class="mt-5">
    <div v-for="(pendampingan_ke, id) in Object.keys(meta.pendampingan || {})" :key="pendampingan_ke">
      <v-divider v-if="id !== 0" class="my-3" />
      <v-list-item class="px-0">
        <v-list-item-avatar color="blue" size="45">
          <v-icon size="30" dark>mdi-calendar</v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="py-0 px-1">
          <v-row>
            <v-col cols="12" lg="5" class="my-auto">
              <div class="body-2 grey--text">Bulan Pelaksanaan</div>
              <div class="body-1 black--text font-weight-medium">
                {{ $getDeepObj(meta, `pendampingan.${pendampingan_ke}`) }}
              </div>
            </v-col>
            <v-col cols="12" lg="4" class="my-auto">
              <div class="body-2 grey--text">Status Laporan</div>
              <v-chip :color="status[getStatusLaporan(pendampingan_ke)]['color']" class="white--text">
                {{ status[getStatusLaporan(pendampingan_ke)]['label'] }}
              </v-chip>
            </v-col>
            <v-col cols="12" lg="3" class="my-auto" v-if="akunInstansiId">
              <div>
                <v-btn
                  :disabled="!laporans[pendampingan_ke]"
                  class="text-capitalize"
                  depressed
                  color="primary"
                  @click="onViewLaporan(pendampingan_ke)"
                >
                  <v-icon left>mdi-eye</v-icon> Lihat Laporan
                </v-btn>
              </div>
            </v-col>
            <v-col
              cols="12"
              lg="3"
              class="my-auto"
              v-else-if="$allow('psp-pelatih-ahli-koordinator-pa-laporan.update')"
            >
              <div>
                <v-btn
                  class="text-capitalize"
                  depressed
                  color="primary"
                  :disabled="(!meta.jadwal[pendampingan_ke] || !meta.binaan) && !$isObject(laporans[pendampingan_ke])"
                  @click="onEditLaporan(pendampingan_ke)"
                >
                  <v-icon left>
                    {{
                      (meta.binaan && meta.jadwal[pendampingan_ke]) || !$isObject(laporans[pendampingan_ke])
                        ? 'mdi-pencil'
                        : 'mdi-eye'
                    }}
                  </v-icon>
                  {{
                    (meta.binaan && meta.jadwal[pendampingan_ke]) || !$isObject(laporans[pendampingan_ke])
                      ? 'Lengkapi'
                      : 'Lihat'
                  }}
                  Laporan
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
export default {
  name: 'KoordinatorFspLaporan',
  props: {
    status: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
    laporans: {
      type: Object,
      default: () => {},
    },
    form: {
      type: String,
      default: '',
    },
    akunInstansiId: {
      default: '',
    },
    masterInstrumen: {
      type: String,
      default: '',
    },
    pendampinganTahun: {
      type: [String, Number],
      default: 2022,
    },
  },
  methods: {
    getStatusLaporan(pendampinganKe) {
      const laporan = this.laporans[pendampinganKe] || {};

      if (!this.$isObject(laporan)) {
        return -1;
      }

      if (this.form === 'daerah' && laporan.is_terlaksana === 0) {
        return 2;
      }

      return laporan.is_lengkap || -1;
    },

    onEditLaporan(pendampinganKe) {
      if (
        !this.meta.jadwal[pendampinganKe] ||
        !this.meta.binaan ||
        (this.laporans[pendampinganKe] && this.laporans[pendampinganKe]['is_edit'] === false)
      ) {
        this.onViewLaporan(pendampinganKe);
        return;
      }

      this.$emit('laporan', { pendampinganKe, form: this.form });
    },

    onViewLaporan(pendampinganKe) {
      this.$emit('laporan', { pendampinganKe, form: this.form, isPreview: true });
    },
  },
};
</script>

<style scoped></style>
